import React from "react";
import Input from "./Input";

const BasicSettingComponent = ({name, settings, handleOnChange, saveStatus, onSave }) => {
  return (
    <div>
      {settings.map((setting, i) => {
        return <Input key={i} {...setting} onChange={(value) => handleOnChange({
          label: setting.label,
          value
        }, name)} />;
      })}
      <button
        className={saveStatus == "Save" ? "bgGreen" : "bgRed disabled"}
        onClick={() => onSave()}
      >
        {saveStatus}
      </button>
    </div>
  );
};

export default BasicSettingComponent;